import { ResourceRepository } from '@telespot/domain';

export interface IDeleteResourceCommand {
  /**
   * Deletes the resource with the given id.
   * Repository errors propagate so callers can decide how to react.
   */
  execute(resourceId: string): Promise<void>;
}

export class DeleteResourceCommand implements IDeleteResourceCommand {
  constructor(private readonly resourceRepository: ResourceRepository) {}

  public async execute(resourceId: string): Promise<void> {
    await this.resourceRepository.delete(resourceId);
  }
}
